export const DegassedJobIcon: React.FC<{ size?: number }> = ({ size = 15 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 10 10" fill="none">
      <circle
        cx="4.5"
        cy="5.22656"
        r="3.75"
        fill="#C78F00"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  );
};
